import React, { Component } from 'react';
import PropTypes from 'prop-types';
import numeral from 'numeral';
import './styles.css';

class Output extends Component {
	render() {
		const { variable, multiplier, decimals } = this.props;
		return (
			<span className="output-number">
				{numeral(variable.value*(multiplier||1)).format(`0,0${decimals ? '.00' : ''}`)}
			</span>
		);
	}
}
Output.propTypes = {
	variable: PropTypes.object
};
export default Output;
